"use client";

import { useEffect, useRef } from "react";

import { HomeHeroScanForm } from "~/components/siteglue/home/home-hero-scan-form";
import { HeroNeuralNetwork } from "~/components/siteglue/landing/hero-neural-network";
import {
  HOMEPAGE_HERO_EYEBROW,
  HOMEPAGE_HERO_H1,
  HOMEPAGE_HERO_SUPPORT,
} from "~/lib/siteglue/landing-redesign/copy";
import { trackLandingEvent } from "~/lib/siteglue/landing-redesign/events";

export function HomeHeroTwoColumn() {
  const ref = useRef<HTMLElement>(null);
  const viewed = useRef(false);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      (entries) => {
        if (!entries.some((entry) => entry.isIntersecting) || viewed.current) return;
        viewed.current = true;
        trackLandingEvent("hero_view", { headline_version: "aro_hro_two_column" });
        observer.disconnect();
      },
      { threshold: 0.4 },
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <section
      ref={ref}
      className="relative isolate overflow-hidden bg-white text-slate-900"
    >
      <HeroNeuralNetwork />
      <div className="relative z-10 mx-auto max-w-6xl px-4 py-12 sm:px-6 sm:py-16 lg:py-20">
        <div className="mx-auto min-w-0 max-w-3xl text-center">
          <p className="text-xs font-semibold uppercase tracking-[0.18em] text-slate-500">
            {HOMEPAGE_HERO_EYEBROW}
          </p>
          <h1 className="mt-3 text-balance text-[clamp(2rem,3.4vw+0.7rem,3.25rem)] font-semibold leading-[1.08] tracking-tight text-slate-900">
            {HOMEPAGE_HERO_H1}
          </h1>
          <p className="mx-auto mt-4 max-w-2xl text-pretty text-base leading-relaxed text-slate-600 sm:text-lg">
            {HOMEPAGE_HERO_SUPPORT}
          </p>
          <div className="mx-auto mt-6 max-w-2xl text-left">
            <HomeHeroScanForm />
          </div>
        </div>
      </div>
    </section>
  );
}
